import { IDropdownOption } from '@fluentui/react'
import { LabelOrientation, Protocol_Type, Wizard_Mode } from '../../shared/enums'
import { IChoiceField, IField } from '../../shared/interfaces'
import { ProtocolWizardReduxState, ProtocolWizardActionTypes, SET_INITIAL_STATE, SET_DOCUMENT_FILE, SET_STEP_INDEX, UPDATE_PROTOCOL_WIZARD_STATE, NEXT_STEP_INDEX, PREVIOUS_STEP_INDEX, SET_PROTOCOL, ADD_ATTACHMENT, LABEL_DIRECTION_TOGGLE, SET_PROTOCOL_WIZARD_TOUCHED, UPDATE_ATTACHMENT, SET_ATTACHMENTS, SET_SELECTED_PRINTER_NAME, SET_DOCUMENT_SCANNER_LOADER, SET_ATTACHMENT_SCANNER_LOADER } from './types'

const initialScannerFields: IField[] = [
    {
        displayName: "Scanner disponibili",
        internalName: "sourceName",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Fronte/Retro",
        internalName: "duplex",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Modalit\u00e0 colore",
        internalName: "pixelType",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Risoluzione (dpi)",
        internalName: "resolution",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField

];

const initialState: ProtocolWizardReduxState = {
    wizardMode: Wizard_Mode.Create,
    protocol: {
        tipoProtocollo: Protocol_Type.Undefined,
        fields: [],
        attachments: [],
        visibilita: []
    },
    docInFields: undefined,
    docOutFields: undefined,
    docInternalFields: undefined,
    stepIndex: 0,
    pageScaledWidth: 0,
    pageScaledHeight: 0,
    labelInfo: undefined,
    //labelInfo: {
    //    labelOrientation: LabelOrientation.Orizzontale,
    //    positionX: 0,
    //    positionY: 0,
    //    labelWidth: 170,
    //    labelHeight: 75,
    //    scale: 1.0
    //},

    valid: true,
    touched: false,
    selectedPrinterName: undefined,
    documentFileSource: "locale",
    attachmentFileSource: "locale",
    documentScannerFields: [...initialScannerFields],
    attachmentScannerFields: [...initialScannerFields],
    documentScannerLoader: false,
    attachmentScannerLoader: false
}

export function protocolWizardReducer(state = initialState, action: ProtocolWizardActionTypes): ProtocolWizardReduxState {
    switch (action.type) {
        case SET_INITIAL_STATE: {
            return {
                ...initialState,
                wizardMode: action.wizardMode
            }
        }
        case SET_DOCUMENT_FILE: {
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    documentFile: action.documentFile
                }
            }
        }
        case SET_ATTACHMENTS: {
            let newAttachments = action.attachmentsFile ? [...action.attachmentsFile] : []

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case ADD_ATTACHMENT: {
            let newAttachments = state.protocol?.attachments ? [...state.protocol?.attachments] : []
            newAttachments.push(action.attachmentFile);

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case UPDATE_ATTACHMENT: {
            let newAttachments = state.protocol?.attachments ? [...state.protocol?.attachments] : []
            let index = newAttachments.findIndex(el => el.id === action.attachmentFile.id)
            if (index != -1)
                newAttachments[index] = { ...action.attachmentFile };

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case SET_PROTOCOL: {
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    ...action.protocol
                }
            }
        }
        case SET_DOCUMENT_SCANNER_LOADER: {
            return {
                ...state,
                documentScannerLoader: action.documentScannerLoader
            }
        }
        case SET_ATTACHMENT_SCANNER_LOADER: {
            return {
                ...state,
                attachmentScannerLoader: action.attachmentScannerLoader
            }
        }
        case SET_SELECTED_PRINTER_NAME: {
            return {
                ...state,
                selectedPrinterName: action.selectedPrinterName
            }
        }
        case UPDATE_PROTOCOL_WIZARD_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        case SET_PROTOCOL_WIZARD_TOUCHED: {
            return {
                ...state,
                touched: true
            }
        }

        case SET_STEP_INDEX: {
            return {
                ...state,
                stepIndex: action.stepIndex
            }
        }
        case NEXT_STEP_INDEX: {
            return {
                ...state,
                stepIndex: state.stepIndex !== undefined ? state.stepIndex + 1 : 0
            }
        }
        case PREVIOUS_STEP_INDEX: {
            return {
                ...state,
                stepIndex: state.stepIndex !== undefined ? state.stepIndex - 1 : 0
            }
        }
        case LABEL_DIRECTION_TOGGLE: {
            let newLabeInfo: any = { ...state.labelInfo }
            newLabeInfo.labelOrientation = state.labelInfo?.labelOrientation == LabelOrientation.Orizzontale ? LabelOrientation.Verticale : LabelOrientation.Orizzontale;
            return {
                ...state,
                labelInfo: newLabeInfo
            }
        }

        default:
            return state
    }
}